import CaseStudyCard from "../../reusables/CaseStudyCard";
import abcd from "../../../assets/images/case-studies/abcd.jpg";

const ABCDCaseStudyCard = () => {
  return (
    <CaseStudyCard
      brand={abcd}
      client="The ABCD company"
      solution="Brand Setup"
      title="From scratch brand setup of an events management & decoration company"
      subtitle="This bakery, catering and decoration company needed to build their brand from scratch"
      link="/solutions/branding-graphic-design"
    >
      <li>
        ✔︎ <span>Logo design</span>
      </li>
      <li>
        ✔︎ <span>Brand identity</span>
      </li>
      <li>
        ✔︎ <span>Social media setup</span>
      </li>
      <li>
        ✔︎ <span>Website development</span>
      </li>
      <li>
        ✔︎ <span>Digital presence launch</span>
      </li>
    </CaseStudyCard>
  );
};

export default ABCDCaseStudyCard;
